/* eslint-disable import/no-cycle */
import { Box, Button } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Branch } from '../../../questionnaireTemplate.enums';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { QuestionBranchSection } from './QuestionBranchSection';

const BRANCH_CONTAINER_PROPS = {
  p: 4,
  borderTop: '1px solid',
  borderColor: 'gray.100',
  borderBottomRadius: 'lg' as const,
};

interface QuestionBranchesContainerProps {
  id: string;
  branches: Branch[];
}

export const QuestionBranchesContainer = React.memo(function QuestionBranchesContainer({
  id,
  branches: schemaBranches,
}: QuestionBranchesContainerProps) {
  const { t } = useTranslation('questionnaireTemplate');
  const activeBranches = QuestionnaireTemplateStore.useStoreState((s) => s.entities.elements[id]?.activeBranches ?? []);
  const activateBranch = QuestionnaireTemplateStore.useStoreActions((a) => a.activateBranch);

  const isFull = activeBranches.length === schemaBranches.length;

  const handleAddFollowUp = () => {
    // Find the first schema branch that isn't active yet
    const nextBranch = schemaBranches.find((b) => !activeBranches.includes(b));
    /* istanbul ignore next */
    if (nextBranch) activateBranch({ elementId: id, branchName: nextBranch });
  };

  return (
    <Box {...BRANCH_CONTAINER_PROPS}>
      {activeBranches.map((branchName) => (
        <QuestionBranchSection
          key={branchName}
          parentId={id}
          branchName={branchName}
          isOnlyBranch={activeBranches.length === 1}
          availableOptions={schemaBranches}
        />
      ))}

      {!isFull && (
        <Button
          size="sm"
          variant="ghost"
          textDecoration="underline"
          fontStyle="italic"
          textColor="#2339A0"
          fontWeight={400}
          onClick={handleAddFollowUp}
          mt={activeBranches.length > 0 ? 2 : 0}
        >
          {t('formBuilder.canvas.element.addFollowUp')}
        </Button>
      )}
    </Box>
  );
});
